import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateCompanyInvoiceApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import { fetchStockStats } from "../../store/Slices/StockStatsSlice";
import { fetchSupplierInvoice } from "../../store/Slices/SupplierInvoiceSlice";
import ItemSelector from "../Selector/ItemSelector";
import CompanySelector from "../Selector/CompanySelector";
import { toLocalYmd } from "../../utils/dateTime";

const AddStockModal = ({ Open, setOpen }) => {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [truckNo, setTruckNo] = useState("");
  const [branch, setBranch] = useState("");
  const [CurDate, setCurDate] = useState(
    toLocalYmd()
  );
  const [loading, setLoading] = useState(false);
  const [qty, setQty] = useState("");
  const [desc, setDesc] = useState("");
  const [SelectedProduct, setSelectedProduct] = useState("");
  const [SelectedCompany, setSelectedCompany] = useState("");

  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!SelectedCompany?._id) WarningToast("Select a company");
    else if (!SelectedProduct?._id) WarningToast("Select an Item");
    else if (!qty || isNaN(qty)) WarningToast("Enter a valid Quantity");
    else if (!CurDate) WarningToast("Select a Date");
    else {
      const branchId = user?.branchId || SelectedProduct?.branchId;
      if (!branchId) {
        WarningToast(
          "Branch is missing. Use a branch login or assign a branch to this item."
        );
      } else {
        try {
          const purchase = Number(SelectedProduct.purchase);
          const qtyNum = Number(qty);
          const payload = {
            itemId: SelectedProduct._id,
            companyId: SelectedCompany._id,
            qty: qtyNum,
            purchase,
            total_amount: purchase * qtyNum,
            invoice_no: Number(invoiceNo),
            truck_no: String(truckNo || "").trim(),
            branchId,
            date: Math.floor(new Date(CurDate).getTime() / 1000),
            desc: (desc && String(desc).trim()) || "-",
          };

          const response = await CreateCompanyInvoiceApi(payload);

          if (response.data.success) {
            setOpen(false);
            SuccessToast("Stock added successfully");
            dispatch(fetchStockStats());
            dispatch(fetchSupplierInvoice());
          } else {
            ErrorToast(response.data.error?.msg || "Server error");
          }
        } catch (err) {
          console.error(err);
          ErrorToast(
            err.response?.data?.error?.msg ||
              err.message ||
              "Failed to add stock"
          );
        }
      }
    }

    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Invoice
        </h1>
        <div className="flex flex-col gap-y-4 px-10">
          <CompanySelector
            SelectedSupplier={SelectedCompany}
            setSelectedSupplier={setSelectedCompany}
          />

          <ItemSelector
            setSelectedProduct={setSelectedProduct}
            SelectedProduct={SelectedProduct}
            SelectedCompany={SelectedCompany}
          />

          <AuthInput
            label="Invoice No"
            placeholder="Enter Invoice No"
            Value={invoiceNo}
            setValue={setInvoiceNo}
            Type={"number"}
          />
          <AuthInput
            label="Truck No"
            placeholder="Enter Truck No"
            Value={truckNo}
            setValue={setTruckNo}
          />
          <AuthInput
            label="Quantity"
            placeholder="Enter Quantity"
            Type="number"
            Value={qty}
            setValue={setQty}
          />
          <AuthInput
            label="Description"
            placeholder="Enter Description"
            Value={desc}
            setValue={setDesc}
          />
          <AuthInput
            label="Date"
            placeholder="Select Date"
            Type="date"
            Value={CurDate}
            setValue={setCurDate}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Add Stock"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddStockModal;
